/**
 * @time 2024/05/30
 * @author 邻家大龙猫
 * @description 英文语言配置文件
 * */

import system from "./system"
import aboutPage from "./aboutPage"
import homePage from "./homePage"
import applicationAreaPage from "./applicationAreaPage"
import productPage from './productPage'
import newsPage from './newsPage'
import joinInPage from './joinInPage'
import productCenterPage from './productCenterPage'
import productProgramPage from './productProgramPage'
import customerServicePage from './customerServicePage'
import contactUs from './contactUs'
import messageRecord from './messageRecord'
import footer from './footer'
import search from './search'
import information from './information'

const en = {
  prefix: 'en_',
  value: 'en',
  label: 'English',
  config: {
    navbar: {
      home: 'Home',
      about: 'About KELK',
      applicationArea: 'Application Area',
      production: 'Product',
      news: 'News',
      joinIn: 'Recruit',
      searchPlaceholder: 'Please enter the keyword',
      searchType: [
        { value: 'product', label: 'Product', path: '/prod_search_list' },
        { value: 'plan', label: 'Article', path: '/search' },
      ]
    },
    subNavbar: {
      productCenter: 'Product Center',
      productProgram: 'Product Program',
      customerService: 'Customer Service',
      contactUs: 'Contact Us',
    },
    system,
    footer,
    // Home Page
    homePage: homePage,
    // About Page
    aboutPage: aboutPage,
    // Application Area Page
    applicationAreaPage: applicationAreaPage,
    // Product Application Page
    productApplication: {
      title: 'Product application',
    },
    // Product Page
    productPage,
    // News Page
    newsPage,
    // Join In Page
    joinInPage,
    // Product Center Page
    productCenterPage,
    // Product Program Page
    productProgramPage,
    // Customer Server Page
    customerServicePage,
    // Contact Us Page
    contactUs,
    messageRecord,
    //
    search,
    information
  }
}



export default en


// WEBPACK FOOTER //
// ./src/config/lang/en/index.js